/**
 * Auth Store (Zustand)
 * Manages authentication state and user session
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '@/lib/auth';
import { VendorProfile } from '@/lib/constants';

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  vendor: VendorProfile | null;
  isLoading: boolean;

  // Actions
  setAuth: (user: User, vendor?: VendorProfile) => void;
  setVendor: (vendor: VendorProfile) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      vendor: null,
      isLoading: false,

      setAuth: (user, vendor) =>
        set({
          isAuthenticated: true,
          user,
          vendor: vendor || null,
        }),

      setVendor: (vendor) =>
        set({
          vendor,
        }),

      clearAuth: () =>
        set({
          isAuthenticated: false,
          user: null,
          vendor: null,
        }),

      setLoading: (loading) =>
        set({
          isLoading: loading,
        }),
    }),
    {
      name: 'vendor-auth-storage', // localStorage key
    }
  )
);

